import { assign } from "lodash";
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import { ZodSharedValidator } from "@medsurf/flat-validators";
import { BaseQuestionComponent } from '../base-question/base-question.component';

@Component({
    selector: 'medsurf-quiz-k-prim-question',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './k-prim-question.component.html',
    styleUrls: ['./k-prim-question.component.scss'],
    standalone: false
})
export class KPrimQuestionComponent extends BaseQuestionComponent<FlatModels.QuestionEntityModels.KprimeQuestion | FlatModels.QuestionEntityModels.TrueFalseQuestion> {
  choices_expanded = false;
  override form = new FormGroup(
    {
      content: new FormControl(''),
      explanation: new FormControl(''),
      solutions: new FormControl(['0']),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.QuestionEntityModels.KprimeQuestionSchema.pick({
          content: true,
          explanation: true,
          solutions: true,
        })
      ),
      updateOn: 'change'
    }
  );

  override updateForm() {
    if (this.index !== undefined && this.question) {
      let update = false;
      if (this.question.content !== this.form.value.content
        || this.question.explanation !== this.form.value.explanation
        || this.question.solutions !== this.form.value.solutions) {
        update = true;
      }
      if (update) {
        // Update Data
        this.form.reset(this.question);
        this.isSubmitted.set(false);
      }
    }
  }

  override onSubmit() {
    if (this.isSubmitted() || this.form.invalid || !this.question) {
      return;
    }
    this.isSubmitted.set(true);
    
    // Update Question
    const question = assign(this.question, this.form.value);

    // Request Update Question
    this.slideAuthorFacade.requestUpdateQuestion(question, 'history.question_update').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.form);
        this.isSubmitted.set(false);
      },
      next: () => {
        this.isSubmitted.set(false);
      }
    });
  }

  trackBy(index: number,
          item: FlatModels.ChoiceEntityModels.Choice) {
    return item.id + item.order || index;
  }

  onChoiceMoved(choices: FlatModels.ChoiceEntityModels.Choice[]) {
    this.slideAuthorFacade.requestRearrangeChoices(this.question, choices).subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result),
    });
  }

  onSolutionChange(data: {index: number, value: string}) {
    let solutions = structuredClone(this.form.value.solutions);
    if (!solutions) {
      solutions = [];
    }
    solutions[data.index] = data.value;
    this.form.patchValue({ solutions });
    this.onSubmit();
  }

  addChoice() {
    // Add Choice
    this.slideAuthorFacade.requestAddChoice(this.question, 'history.choice_add').subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result),
      next: () => {
        this.choices_expanded = true;
      }
    });
  }
}
